import { createAsyncAction } from 'typesafe-actions';
import { UpdatePasswordDto } from './updatePassword.dtos';

export const updatePasswordActions = createAsyncAction(
  'UPDATE_PASSWORD_REQUEST',
  'UPDATE_PASSWORD_SUCCESS',
  'UPDATE_PASSWORD_ERROR'
)<UpdatePasswordDto, string, string>();
